import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "ReactionsInMessageList" */ './lazyIndex'),
    { name: 'ReactionsInMessageList' }
);

export const lazyFetchReactionDataForMessageList: LazyAction<
    typeof lazyIndex.fetchReactionDataForMessageList,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.fetchReactionDataForMessageList);
